export default {
  Common: {
    Title: "Danh bạ",
    Code: "Mã khách hàng",
    Name: "Tên khách hàng",
    Email: "Email",
    PhoneNumber: "Số điện thoại",
    TaxCode: "Mã số thuế",
    Address: "Địa chỉ",
    Type: "Loại khách hàng",
  },
  List: {},
  Detail: {
    SelectPermission: "Chọn quyền",
    Title: "Vai trò quyền hạn",
    AddTitle: "Thêm khách hàng",
    FullName: "Họ và tên",
    EditTitle: "Sửa khách hàng",
    InfoGeneral: "Thông tin chung",
    DuplicateTitle: "Nhân bản vai trò",
    Code: "Mã khách hàng",
    RoleName: "Tên vai trò",
    Email: "Email",
    PhoneNumber: "Số điện thoại",
    RoleCode: "Mã vai trò",
    Gender: "Giới tính",
    Description: "Mô tả",
    All: "Toàn quyền",
    Watch: "Xem",
    Use: "Sử dụng",
    Add: "Thêm",
    Edit: "Sửa",
    Delete: "Xóa",
    Report: "Báo cáo",
    Approve: "Xác nhận",
    Print: "In",
    Import: "Nhập khẩu",
    Export: "Xuất khẩu",
    Transfer: {
      Localtion: "Điều chuyển vị trí tài sản",
      Allocation: "Điều chuyển đối tượng sử dụng",
      OrgUnit: "Điều chuyển đơn vị quản lý",
    },
    Repair: {
      Broken: "Đánh dấu hỏng",
      Repair: "Sửa chữa tài sản",
      Reuse: "Đưa vào sử dụng lại",
      History: "Ghi lịch sử sửa chữa tài sản",
      Schedule: "Lập lịch sửa chữa",
    },
    Maintain: {
      Maintain: "Bảo dưỡng tài sản",
      Reuse: "Đưa vào sử dụng lại",
      History: "Ghi lịch sử bảo dưỡng tài sản",
      Schedule: "Lập lịch bảo dưỡng",
    },
    Inventory: {
      Schedule: "Lập lịch kiểm kê",
    },
    LostCancelLiquidation: {
      Lost: "Đánh dấu mất",
      Cancel: "Đánh dấu huỷ",
      RequestLiquidation: "Đề nghị thanh lý",
      Liquidation: "Thanh lý tài sản",
    },
  },
};
